/**
 * Authentication utility functions
 */

/**
 * Redirects the user to the SSO login endpoint
 * Works in both development and production environments
 */
export const redirectToSSO = (): void => {
  const apiBaseUrl = import.meta.env.PROD
    ? '/api'
    : import.meta.env.VITE_API_URL || 'http://localhost:8080/api';
  window.location.href = `${apiBaseUrl}/auth/login`;
};
